export default __webpack_public_path__ + "alberta-ic-attachments.4e8585e0be2a12fd80b2.svg";